export default "__VITE_ASSET__BASwxerm__"